module.exports = __webpack_public_path__ + "img/area-part4-242.f95354de.png";